/**
 * Extracts a readable message from a failed response body.
 *
 * The API answers `{error, code}`, adds a `details` array on schema failures,
 * and replies in plain text on the auth routes.
 *
 * @param {object|string|undefined} data response body of the failed request
 * @returns {string|null} the message, or null when the body carries none
 */
export function buildErrorMessage(data) {
  if (typeof data === "string") return data.trim() || null;
  if (!data) return null;

  const message = data.error || data.message || null;
  if (!Array.isArray(data.details) || data.details.length === 0) return message;

  const details = data.details
    .map(({ path, message: detail }) => (path ? `${path}: ${detail}` : detail))
    .join(", ");

  return message ? `${message} (${details})` : details;
}
